import { ActivatedRoute, Router,  } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoggerService } from '@app/logger/logger.service';
import { LoginDialogComponent } from './login-dialog.component';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from '@app/auth/authentication.service';

const log = new LoggerService('LOGIN DIALOG ENTRY COMPONENT');

@Component({ 
  template: '',
  encapsulation: ViewEncapsulation.Emulated,
})
export class LoginDialogEntryComponent implements OnInit {
  constructor(
    public dialog: MatDialog, 
    private authenticationService: AuthenticationService,
    private router: Router,
  ) {}

  ngOnInit(){
    this.openDialog();
  }
  
  /**
   * @description Función que se ejecuta al inciar el componente de angular, abre el dialog component. Este componente está diseñado para ser utilizado en conjunto con un router
   */
  public async openDialog() {
    //log.debug('[openDialog] Opening Login Dialog.');
    const userAlreadyLoggedIn =  await this.authenticationService.isLoggedIn()
    if(!userAlreadyLoggedIn){
      const dialogRef = this.dialog.open(LoginDialogComponent, {
        panelClass:'login-dialog'
      }); 
      dialogRef.afterClosed().subscribe(()=>{  
        this.router.navigate(['/home/main']);
      });
    } else {
      this.router.navigate(['/']) 
    } 
  }
}
